module.exports = __webpack_public_path__ + "static/media/groupLogoMarketing.fac7ccac.svg";